/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import { el, hide } from '@amazon/vinyl-tsx'

export function hideMainLoader() {
    const view = el('#mainLoader')
    hide(view)
}
